import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import moment from "moment";
import cx from "classnames";

// Provider
import AppProvider, { AppContext, SELFCAED_MENU_SET,SELFCAED_MENU_ALL_SET } from "../../components/AppProvider";

import { PostApi1912, PostApi1901 } from "../../modules/network/padoPost";

// Utils
import { _O } from "../../modules/utils";
import { Container, openLayerFn, closeLayerFn, openAlertPopup, openLayerFn2 } from "../Layout";

// UI
import { Doctor } from "../../resources/Assets";

// Temp Images
import _T_USER from "../../resources/images/user/user_photo_circle.jpg";
import _T_MEAL from "../../resources/images/user/user_meal_photo01.jpg";
import _ICON_PLUS from "../../resources/images/icon/icon_plus_circle_min.png";
import _ICON_MINUS from "../../resources/images/icon/icon_minus_circle_min.png";
import { getCookie } from "../../modules/utils/cookie";
import { userHabit } from "../../modules/utils/UserHabit";

export const DoctorMessage = (props) => {
    const {userinfo} = useContext(AppContext);
    const { image, message } = props;
    return (
        <div className="blacklayer-container doctor-message-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea">
                <div className="blgrn-box vertical">
                    <div className="blgr-title">주치의 메세지</div>
                    <div className="doctor-message">
                        <div className="illust-circle">
                            <img src={image} alt="" />
                            {/* <!-- 여성 웃음 --> */}
                            {/* <!-- <img src="images/sub/illust_circle_doctor1_2.png" alt="" /> --> <!-- 여성 심각 -->
                            <!-- <img src="images/sub/illust_circle_doctor2.png" alt="" /> -->  <!-- 남성 웃음 -->
                            <!-- <img src="images/sub/illust_circle_doctor2_1.png" alt="" /> --> <!-- 남성 심각 --> */}
                        </div>
                        {(message === "MAIN") && <MessageContentsMain userinfo={userinfo} />}
                        {(message === "INPUT") && <MessageContentsInput userinfo={userinfo} />}
                        
                        <div className="btn-area">
                            <a className="btn-round wht close-doctor-message">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const DoctorMessageImsi = (props) => {
    const {userinfo} = useContext(AppContext);
    const { image, message } = props;

    const imsi = () => {
        window.java.sendTrsmId('648', '271', window.location.href);
    }

    return (
        <div className="blacklayer-container doctor-message-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea">
                <div className="blgrn-box vertical">
                    <div className="blgr-title">주치의 메세지</div>
                    <div className="doctor-message">
                        <div className="illust-circle">
                            <img src={image} alt="" />
                            {/* <!-- 여성 웃음 --> */}
                            {/* <!-- <img src="images/sub/illust_circle_doctor1_2.png" alt="" /> --> <!-- 여성 심각 -->
                            <!-- <img src="images/sub/illust_circle_doctor2.png" alt="" /> -->  <!-- 남성 웃음 -->
                            <!-- <img src="images/sub/illust_circle_doctor2_1.png" alt="" /> --> <!-- 남성 심각 --> */}
                        </div>
                        
                        <MessageContentsMain2 />
                        
                        <div className="btn-area">
                            <a className="btn-round wht close-doctor-message" onClick={()=>imsi()}>
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const MessageContentsMain = (props) => {
    const {userinfo} = props;
    return (
        <div className="message-box">
        {userinfo.userName}님 건강관리에 함께 하겠습니다.
            <br />
            힘내세요!
        </div>
    );
}

const MessageContentsMain2 = (props) => {
    const {userinfo} = props;
    return (
        <div className="message-box">
            장호준님 대장내시경 영상이
            <br />
            전달되었습니다.
        </div>
    );
}

const MessageContentsInput = (props) => {
    const {userinfo} = props;
    return (
        <div className="message-box">
            {userinfo.userName}님 오늘하루 혈압관리도 기대하겠습니다.
        </div>
    );
}

const drinkKindToText = (param) => {
    const drinkList = [
        {
            title: "맥주",
            code: "A"
        },
        {
            title: "소주",
            code: "B"
        },
        {
            title: "막걸리",
            code: "C"
        },
        {
            title: "와인",
            code: "D"
        },
        {
            title: "기타",
            code: "Z"
        }
    ];

    let rtnValue;

    if(param.drnkKind && param.drnkKind != "") {
        rtnValue = drinkList.filter((e) => e.code === param.drnkKind)[0].title;
    } else {
        rtnValue = "종류";
    }

    return rtnValue;
}

export const HealthInput = memo((props) => {
    // 각 파라미터 값 state로 활용할지
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    const {healthInfo, request1902} = props;

    // step1
    // const [blodType, setBlodType] = useState("A");
    // const [blodTypeDtl, setBlodTypeDtl] = useState("RH+");

    // step2
    const [alrgYn, setAlrgYn] = useState("N");
    const [mdclHistType, setMdclHistType] = useState("N");
    const [famHistType, setFamHistType] = useState("N");

    const [crbrYn, setCrbrYn] = useState("N");
    const [hbpYn, setHbpYn] = useState("N");
    const [dabtYn, setDabtYn] = useState("N");

    // step3
    const [infzVcntYn, setInfzVcntYn] = useState("N");
    const [pnmnVcntYn, setpnmnVcntYn] = useState("N");
    const [dlssYn, setDlssYn] = useState("N");
    const [asctDissCd, setAsctDissCd] = useState("E");
    const [smokYn, setSmokYn] = useState("N");
    const [drnkYn, setDrnkYn] = useState("N");
    const [drnkKind, setDrnkKind] = useState("");

    //음주 항목
    const drinkList = [
        {
            title: "맥주",
            code: "A"
        },
        {
            title: "소주",
            code: "B"
        },
        {
            title: "막걸리",
            code: "C"
        },
        {
            title: "와인",
            code: "D"
        },
        {
            title: "기타",
            code: "Z"
        }
    ];

    // 가족력 LIST (Family History)
    const fhList = [
        {
            title: '뇌졸증(중풍)',
            code: '01'
        },
        {
            title: '고혈압',
            code: '03'
        },
        {
            title: '당뇨',
            code: '04'
        },
        {
            title: '위암',
            code: '07'
        },
        {
            title: '간암',
            code: '08'
        },
        {
            title: '대장암',
            code: '09'
        },
        {
            title: '유방암',
            code: '10'
        },
        {
            title: '자궁경부암',
            code: '11'
        },
        {
            title: '기타(암포함)',
            code: '99'
        },
        {
            title: '심장병(심근경색/협심증)',
            code: '02'
        }
    ];

    // 현병력 LIST (Present Illness)
    const piList = [
        {
            title: '뇌졸증',
            code: '01'
        },
        {
            title: '심장병',
            code: '02'
        },
        {
            title: '고혈압',
            code: '03'
        },
        {
            title: '당뇨병',
            code: '04'
        },
        {
            title: '이상지질',
            code: '05'
        },
        {
            title: '폐결핵',
            code: '06'
        },
        {
            title: '위암',
            code: '07'
        },
        {
            title: '간암',
            code: '08'
        },
        {
            title: '대장암',
            code: '09'
        },
        {
            title: '유방암',
            code: '10'
        },
        {
            title: '자궁경부암',
            code: '11'
        },
        {
            title: '기타',
            code: '99'
        }
    ];

    // 예방접종 리스트
    const inoculationList = [
        {
            title: 'B형간염'
            , id: 'hpttsBVcnt'
            , value: healthInfo ? healthInfo.hpttsBVcnt : ""
        },
        {
            title: 'A형간염'
            , id: 'hpttsAVcnt'
            , value: healthInfo ? healthInfo.hpttsAVcnt : ""
        },
        {
            title:'폐렴구균 13가(프리베나)'
            , id: 'pnmn13Vcnt'
            , value: healthInfo ? healthInfo.pnmn13Vcnt : ""
        },
        {
            title:'폐렴구균 23가'
            , id: 'pnmn23Vcnt'
            , value: healthInfo ? healthInfo.pnmn23Vcnt : ""
        },
        {
            title:'대상포진'
            , id: 'hrpztVcnt'
            , value: healthInfo ? healthInfo.hrpztVcnt : ""
        },
        {
            title:'독감'
            , id: 'infzVcnt'
            , value: healthInfo ? healthInfo.infzVcnt : ""
        },
        {
            title:'파상풍'
            , id: 'ttnsVcnt'
            , value: healthInfo ? healthInfo.ttnsVcnt : ""
        },
        {
            title:'Tdap(디프테리아, 파상풍, 백일해)'
            , id: 'TdapVcnt'
            , value: healthInfo ? healthInfo.TdapVcnt : ""
        },
        {
            title:'자궁경부암(여자)'
            , id: 'crvclCncrVcnt'
            , value: healthInfo ? healthInfo.crvclCncrVcnt : ""
        }
    ];

    const antiBodyTest = [
        {
            title: 'A형간염'
            , id: 'hpttsATest'
            , value: healthInfo ? healthInfo.hpttsATest : ""
        },
        {
            title: 'B형간염'
            , id: 'hpttsBTest'
            , value: healthInfo ? healthInfo.hpttsBTest : ""
        },
        {
            title: 'C형간염'
            , id: 'hpttsCTest'
            , value: healthInfo ? healthInfo.hpttsCTest : ""
        }
    ]

    let date = new Date();
    let toYear = date.getFullYear();
    let fromYear = (userinfo && userinfo.birth) ? userinfo.birth.substring(0,4) : toYear
    let yearList = [];

    for(let i=toYear; i>(fromYear-1); i--) {
        yearList.push(i);
    }
    
    // for(let i=fromYear; i<=toYear; i++) {
    //     yearList.push(i);
    // }

    useEffect(() => {
        if(healthInfo) {
            setAlrgYn(healthInfo.alrgYn);
            setMdclHistType(healthInfo.mdclHistYn);
            setFamHistType(healthInfo.fmlyHistYn);
            setCrbrYn(healthInfo.crbrYn);
            setHbpYn(healthInfo.hbpYn);
            setDabtYn(healthInfo.dabtYn);
            setInfzVcntYn(healthInfo.infzVcntYn);
            setpnmnVcntYn(healthInfo.pnmnVcntYn);
            setDlssYn(healthInfo.dlssYn);
            setAsctDissCd(healthInfo.asctDissCd);
            setSmokYn(healthInfo.smokYn);
            setDrnkYn(healthInfo.drnkYn);
        }

        $(".select-toggle-inputbox1 ul li a").click(function () {
            if ($(this).hasClass("on")) {
                $(".toggle-input1").show();
            } else {
                $(".toggle-input1").hide();
            }
        });
    }, [healthInfo]);


    const request1901 = (userinfo, cfg, saveStep
                        , blodType, blodTypeDtl, hght, wght, bmi, smokYn, smokDtl, drnkYn, drnkDtl, drnkKind, drnkCnt
                        , alrgYn, alrgDtl, mdclHistType, mdclHistDtl, mdclHistDgnssDesc, mdclHistDrug, mdclHistDrugDesc, fmlyHistYn, flmyHistDtl, flmyHistDtlDesc
                        , hpttsBVcnt, hpttsAVcnt, pnmn13Vcnt, pnmn23Vcnt, hrpztVcnt, infzVcnt, ttnsVcnt, TdapVcnt, crvclCncrVcnt
                        , hpttsATest, hpttsBTest, hpttsCTest) => {
            PostApi1901(userinfo, cfg, phonecfg, saveStep
                        , blodType, blodTypeDtl, hght, wght, bmi, smokYn, smokDtl, drnkYn, drnkDtl, drnkKind, drnkCnt
                        , alrgYn, alrgDtl, mdclHistType, mdclHistDtl, mdclHistDgnssDesc, mdclHistDrug, mdclHistDrugDesc, fmlyHistYn, flmyHistDtl, flmyHistDtlDesc
                        , hpttsBVcnt, hpttsAVcnt, pnmn13Vcnt, pnmn23Vcnt, hrpztVcnt, infzVcnt, ttnsVcnt, TdapVcnt, crvclCncrVcnt
                        , hpttsATest, hpttsBTest, hpttsCTest)
            .then(res => {
                if(res.resultMsg === 'SUCCESS') {
                    if(saveStep === "3") {
                        request1902(userinfo, cfg);
                    }
                } else {
                    console.log("LOGOUT!!!");
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const save = (step) => {
        // checkBox 다중선택 값 추가 mdclHistDgnss, mdclHistDrug (name)
        let mdclHistDgnss = '';
        let mdcnHistDrug = '';
        let fmlyHistDtl = '';

        $("input:checkbox[name=mdclHistDgnss]:checked").each(function(index) {
            if (index != 0) {
                mdcnHistDrug += ', ';
            }
            mdcnHistDrug += $(this).val();
        });
        
        $("input:checkbox[name=mdcnHistDrug]:checked").each(function(index) {
            if (index != 0) {
                mdclHistDgnss += ', ';
            }
            mdclHistDgnss += $(this).val();
        });
        
        $("input:checkbox[name=fmlyHistDtl]:checked").each(function(index) {
            if (index != 0) {
                fmlyHistDtl += ', ';
            }
            fmlyHistDtl += $(this).val();
        });

        request1901(
            userinfo, cfg, step
            , $("#blodTypeValue").text(), $("#blodTypeDtlValue").text(), $("#hghtInput").val(), $("#wghtInput").val(), $("#bmiInput").val(), smokYn, $("#smokDtlInput").val(), drnkYn, $("#drnkDtlInput").val(), drnkKind, $("#drnkTimeInput").val()
            , alrgYn, $("#alrgDtlInput").val(), mdclHistType, mdclHistDgnss, $("#piInput").val(), mdcnHistDrug, $("#piInput2").val(), famHistType, fmlyHistDtl, $("#fhInput").val()
            , $("#hpttsBVcnt").text(), $("#hpttsAVcnt").text(), $("#pnmn13Vcnt").text(), $("#pnmn23Vcnt").text(), $("#hrpztVcnt").text(), $("#infzVcnt").text(), $("#ttnsVcnt").text(), $("#TdapVcnt").text(), $("#crvclCncrVcnt").text()
            , $("#hpttsATest").text(), $("#hpttsBTest").text(), $("#hpttsCTest").text()
        );
    }

    const maxLengthCheck = (e) => {
        if (e.target.value.length > e.target.maxLength) { 
            e.target.value = e.target.value.slice(0, e.target.maxLength); 
        }

    }

    const circulateBmi = (wght, hght, target) => { 
        if(wght != '' && hght != '') {
            $('#'+ target).val(
                ((wght / (hght * hght)) * 10000).toFixed(2)
            );
        } else {
            $('#' + target).val(
                '미등록'
            );
        }
    }

    const settingBmiValue = () => {
        circulateBmi($("#wghtInput").val(), $("#hghtInput").val(), 'bmiInput');
    }

    const toggleAction = (target) => {
        $("#"+target).toggle();
        $("#"+target+"List").toggle();
        $("#"+target+"Plus").toggle();
        $("#"+target+"Minus").toggle();
    }

    useEffect(() => {
        settingBmiValue();
    }, [healthInfo]);

    return (
      <div className="blacklayer-container health-input-layer">
        <div className="bl-blind"></div>
        <div className="in-layerarea nobtn">
          <div className="blgrn-box">
            <div className="blgr-title">나의 건강정보 입력</div>
            <div className="health-input-contain">
              <div className="step-section">
                <div className="steps-bar">
                  <ul>
                    <li>
                      <span className="on">STEP 1</span>
                    </li>
                    <li>
                      <span>STEP 2</span>
                    </li>
                    <li>
                      <span>STEP 3</span>
                    </li>
                  </ul>
                </div>
                <div className="input-list">
                  <ul>
                    <li>
                      <div className="title">혈액형</div>
                      <div className="select-h">
                        <div className="select-custom-box">
                          <a href={void 0} className="btn-select inb" id="blodTypeValue">
                            {!healthInfo ? "A" : healthInfo.blodType}
                          </a>
                          <ul>
                            <li>
                              <a>A</a>
                            </li>
                            <li>
                              <a>B</a>
                            </li>
                            <li>
                              <a>AB</a>
                            </li>
                            <li>
                              <a>O</a>
                            </li>
                          </ul>
                        </div>

                        <div className="select-custom-box">
                          <a href={void 0} className="btn-select inb" id="blodTypeDtlValue">
                            {healthInfo && healthInfo.blodTypeDtl}
                            {!healthInfo && "Rh+"}
                          </a>
                          <ul>
                            <li>
                              <a>Rh+</a>
                            </li>
                            <li>
                              <a>Rh-</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="title">키</div>
                      <div className="backword">
                        <i>cm</i>
                        <input
                          type="number"
                          pattern="\d*"
                          id="hghtInput"
                          defaultValue={healthInfo && healthInfo.hght}
                          onChange={() => settingBmiValue()}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="title">몸무게</div>
                      <div className="backword">
                        <i>kg</i>
                        <input
                          type="number"
                          pattern="\d*"
                          id="wghtInput"
                          defaultValue={healthInfo && healthInfo.wght}
                          onChange={() => settingBmiValue()}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="title">BMI</div>
                      <div className="backword">
                        <input type="text" id="bmiInput" readOnly />
                      </div>
                    </li>

                    <li>
                      <div className="title">생활습관</div>
                      <div className="list-select">
                        <div>
                          <div className="txt">흡연</div>
                          <div className="select-custom-box select-toggle-inputbox1">
                            <a href={void 0} className="btn-select inb">
                              {healthInfo && healthInfo.smokYn === "Y" ? "유" : "무"}
                            </a>
                            <ul>
                              <li>
                                <a onClick={() => setSmokYn("N")}>무</a>
                              </li>
                              <li>
                                <a onClick={() => setSmokYn("Y")} className="on">
                                  유
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div>
                          <div
                            className="backword lw toggle-input1"
                            style={smokYn === "N" ? { display: "none" } : { display: "" }}
                          >
                            <i>개피/1일</i>
                            <input
                              type="number"
                              pattern="\d*"
                              id="smokDtlInput"
                              placeholder="흡연량"
                              defaultValue={healthInfo && healthInfo.smokDtl}
                            />
                          </div>
                        </div>
                        <div>
                          <div className="txt">음주</div>
                          <div className="select-custom-box select-toggle-inputbox2">
                            <a href={void 0} className="btn-select inb">
                              {healthInfo && healthInfo.drnkYn === "Y" ? "유" : "무"}
                            </a>
                            <ul>
                              <li>
                                <a onClick={() => setDrnkYn("N")}>무</a>
                              </li>
                              <li>
                                <a onClick={() => setDrnkYn("Y")} className="on">
                                  유
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div style={drnkYn === "N" ? { display: "none" } : { display: "" }}>
                          <div
                            className="select-custom-box select-toggle-inputbox2"
                            style={{ width: "32%", marginLeft: "0px" }}
                          >
                            <a className="btn-select inb">
                              {healthInfo ? drinkKindToText(healthInfo) : "종류"}
                            </a>
                            <ul>
                              {drinkList.map((m, i) => (
                                <li key={i} style={{ paddingRight: "0px" }}>
                                  <a onClick={() => setDrnkKind(m.code)}>{m.title}</a>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div
                            className="backword lw toggle-input2"
                            style={{ display: "inline-block", marginLeft: "2%", width: "32%" }}
                          >
                            <i style={{ right: "7px" }}>회/주</i>
                            <input
                              type="number"
                              pattern="\d*"
                              id="drnkTimeInput"
                              placeholder="음주횟수"
                              defaultValue={healthInfo && healthInfo.drnkCnt}
                            />
                          </div>

                          {/* <div className="backword lw toggle-input2" style={{display:'inline-block', marginLeft:'108px', width:'calc(69% - 108px)', marginTop:'8px'}}> */}
                          <div
                            className="backword lw toggle-input2"
                            style={{ display: "inline-block", marginLeft: "2%", width: "32%" }}
                          >
                            <i style={{ right: "7px" }}>병/회</i>
                            <input
                              type="number"
                              pattern="\d*"
                              id="drnkDtlInput"
                              placeholder="음주량"
                              defaultValue={healthInfo && healthInfo.drnkDtl}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="tbns-area">
                  <a
                    onClick={() => request1902(userinfo, cfg)}
                    className="btn-round gray btn-cancel"
                  >
                    취소
                  </a>
                  <a className="btn-round wht btn-next">다음</a>
                </div>
              </div>

              <div className="step-section" style={{ display: "none" }}>
                <div className="steps-bar">
                  <ul>
                    <li>
                      <span>STEP 1</span>
                    </li>
                    <li>
                      <span className="on">STEP 2</span>
                    </li>
                    <li>
                      <span>STEP 3</span>
                    </li>
                  </ul>
                </div>

                <div className="input-list">
                  <ul>
                    <li>
                      <div className="title">알레르기</div>
                      <div className="select-intext">
                        {/* <!-- "무"가 선택된 상태 :  입력칸 없시  --> */}
                        <div
                          className={
                            alrgYn === "Y"
                              ? "select-custom-box select-check-oninput chk"
                              : "select-custom-box select-check-oninput"
                          }
                        >
                          <a className="btn-select inb">
                            {healthInfo && healthInfo.alrgYn === "Y" ? "유" : "무"}
                          </a>
                          <ul>
                            <li>
                              <a onClick={() => setAlrgYn("N")}>무</a>
                            </li>
                            <li>
                              <a onClick={() => setAlrgYn("Y")}>유</a>
                            </li>
                          </ul>
                        </div>

                        {/* <!-- "유"선택시 : 입력칸 노출 - solo 클래스 삭제 후 input창 노출--> */}
                        {alrgYn === "Y" && (
                          <input
                            type="text"
                            id="alrgDtlInput"
                            placeholder="알레르기를 입력해주세요."
                            className="select-on-inputbox"
                            defaultValue={
                              healthInfo && healthInfo.alrgDtl ? healthInfo.alrgDtl : ""
                            }
                          />
                        )}
                        {/* {alrgYn === "Y" 
                                                &&  <input type="text" id="alrgDtlInput" placeholder="알레르기를 입력해주세요." className="select-on-inputbox" onClick={()=>_O.OpenMenu("/sm/allergy/")}
                                                            defaultValue={healthInfo.alrgDtl}
                                                    />
                                            } */}
                      </div>
                    </li>
                    <li>
                      <div className="title">병력</div>
                      <div className="select-intext">
                        <div className="select-custom-box">
                          <a href={void 0} className="btn-select inb">
                            {!healthInfo
                              ? "없음"
                              : healthInfo.mdclHistYn === "N"
                              ? "무"
                              : healthInfo.mdclHistYn === "Y" && "유"}
                          </a>
                          <ul>
                            <li>
                              <a onClick={() => setMdclHistType("N")}>무</a>
                            </li>
                            <li>
                              <a onClick={() => setMdclHistType("Y")}>유</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {mdclHistType === "Y" && (
                        <div className="list-select">
                          <div>
                            <div
                              className="txt"
                              style={{ width: "100%", margin: "15px 0px" }}
                              onClick={() => toggleAction("diseaseHist")}
                            >
                              다음과 같은 질병으로 진단을 받으셨습니까?
                              <img
                                src={_ICON_PLUS}
                                style={{
                                  width: "20px",
                                  position: "absolute",
                                  margin: "-1.5px 10px",
                                }}
                                id="diseaseHistPlus"
                              />
                              <img
                                src={_ICON_MINUS}
                                style={{
                                  width: "20px",
                                  position: "absolute",
                                  margin: "-1.5px 10px",
                                  display: "none",
                                }}
                                id="diseaseHistMinus"
                              />
                            </div>

                            <div
                              style={{ paddingLeft: "10px", display: "none" }}
                              id="diseaseHistList"
                            >
                              <LabelList
                                dataList={piList}
                                checkList={healthInfo && healthInfo.mdclHistDgnss}
                                target="piInput"
                                name="mdclHistDgnss"
                              />
                              <input
                                type="text"
                                id="piInput"
                                maxLength="20"
                                style={{ display: "none" }}
                              />
                            </div>

                            {
                              <div
                                style={{ paddingLeft: "10px", fontSize: "13px", color: "#fff" }}
                                id="diseaseHist"
                              >
                                {healthInfo &&
                                  healthInfo.mdclHistDgnss &&
                                  "(" + healthInfo.mdclHistDgnss + ")"}
                              </div>
                            }
                          </div>

                          <div>
                            <div
                              className="txt"
                              style={{ width: "100%", margin: "15px 0px" }}
                              onClick={() => toggleAction("cureHist")}
                            >
                              다음과 같은 질환으로 약물 치료 중이십니까?
                              <img
                                src={_ICON_PLUS}
                                style={{
                                  width: "20px",
                                  position: "absolute",
                                  margin: "-1.5px 10px",
                                }}
                                id="cureHistPlus"
                              />
                              <img
                                src={_ICON_MINUS}
                                style={{
                                  width: "20px",
                                  position: "absolute",
                                  margin: "-1.5px 10px",
                                  display: "none",
                                }}
                                id="cureHistMinus"
                              />
                            </div>

                            <div style={{ paddingLeft: "10px", display: "none" }} id="cureHistList">
                              <LabelList
                                dataList={piList}
                                checkList={healthInfo && healthInfo.mdclHistDrug}
                                target="piInput2"
                                name="mdcnHistDrug"
                              />
                              <input
                                type="text"
                                id="piInput2"
                                maxLength="20"
                                style={{ display: "none" }}
                              />
                            </div>

                            {
                              <div
                                style={{ paddingLeft: "10px", fontSize: "13px", color: "#fff" }}
                                id="cureHist"
                              >
                                {healthInfo &&
                                  healthInfo.mdclHistDrug &&
                                  "(" + healthInfo.mdclHistDrug + ")"}
                              </div>
                            }
                          </div>
                        </div>
                      )}
                    </li>
                    <li>
                      <div className="title">가족력</div>

                      <div className="select-custom-box chk">
                        <a href={void 0} className="btn-select inb">
                          {!healthInfo
                            ? "무"
                            : healthInfo.fmlyHistYn === "N"
                            ? "무"
                            : healthInfo.fmlyHistYn === "Y" && "유"}
                        </a>
                        <ul>
                          <li>
                            <a onClick={() => setFamHistType("N")}>무</a>
                          </li>
                          <li>
                            <a onClick={() => setFamHistType("Y")}>유</a>
                          </li>
                        </ul>
                      </div>

                      {famHistType === "Y" && (
                        <div className="list-select">
                          <div>
                            <div
                              className="txt"
                              style={{ width: "100%", margin: "15px 0px" }}
                              onClick={() => toggleAction("famHist")}
                            >
                              부모, 형제, 자매 중에 다음 질환을 앓았거나 해당 질환으로 사망한 경우가
                              있으십니까?
                              <img
                                src={_ICON_PLUS}
                                style={{
                                  width: "20px",
                                  position: "absolute",
                                  margin: "-1.5px 10px",
                                }}
                                id="famHistPlus"
                              />
                              <img
                                src={_ICON_MINUS}
                                style={{
                                  width: "20px",
                                  position: "absolute",
                                  margin: "-1.5px 10px",
                                  display: "none",
                                }}
                                id="famHistMinus"
                              />
                            </div>

                            <div style={{ paddingLeft: "10px", display: "none" }} id="famHist">
                              <LabelList
                                dataList={fhList}
                                checkList={healthInfo && healthInfo.fmlyHistDtl}
                                target="fhInput"
                                name="fmlyHistDtl"
                              />
                              <input
                                type="text"
                                id="fhInput"
                                maxLength="20"
                                style={{ display: "none" }}
                              />
                            </div>

                            {
                              <div
                                style={{ paddingLeft: "10px", fontSize: "13px", color: "#fff" }}
                                id="famHist"
                              >
                                {healthInfo &&
                                  healthInfo.fmlyHistDtl &&
                                  "(" + healthInfo.fmlyHistDtl + ")"}
                              </div>
                            }
                          </div>
                        </div>
                      )}
                    </li>
                  </ul>
                </div>

                <div className="tbns-area">
                  <a href={void 0} className="btn-round gray btn-prev">
                    이전
                  </a>
                  <a className="btn-round wht btn-next">다음</a>
                </div>
              </div>

              <div className="step-section" style={{ display: "none" }}>
                <div className="steps-bar">
                  <ul>
                    <li>
                      <span>STEP 1</span>
                    </li>
                    <li>
                      <span>STEP 2</span>
                    </li>
                    <li>
                      <span className="on">STEP 3</span>
                    </li>
                  </ul>
                </div>

                <div className="input-list">
                  <ul>
                    <li>
                      <div className="title">예방접종</div>
                      <div className="list-select">
                        <InoculationList dataList={inoculationList} yearList={yearList} />
                      </div>
                    </li>

                    <li>
                      <div className="title">항체검사</div>
                      <div className="list-select">
                        <InoculationList dataList2={antiBodyTest} yearList={yearList} />
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="tbns-area">
                  <a className="btn-round gray btn-prev">이전</a>
                  <a onClick={() => save("3")} className="btn-round wht btn-apply">
                    확인
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
});

const LabelList = (props) => {
    const { userinfo } = useContext(AppContext);
    const { dataList, checkList, target, name } = props;

    const onClickEtc = (e, code) => {
        if(code == '99') {
            if(e.target.checked == true) {
                $("#"+target).show();
            } else {
                $("#"+target).hide();
            }
        }
    }

    const setCheckYn = (data) => {
        if(checkList.indexOf(data.title) != '-1') {
            $("#" + target + data.code).prop("checked", true)
        }
    }

    useEffect(() => {
        if(checkList) {
            dataList.map((list) => (
                setCheckYn(list)
            ))
        }
    }, []);

    return(
        <Fragment>
            {
                dataList.map((list,i) => (
                    userinfo.sex === "1" 
                        ?  (list.title != '자궁경부암' && list.title != '유방암') &&
                            <label className="check-box" style={{width:'45%', fontSize:'13px', color:'#fff', marginBottom:'25px'}} key={i}>
                                <input type="checkbox" name={name} value={list.title} id={target + list.code} onClick={(e)=>onClickEtc(e, list.code)} /><i></i>{list.title}
                            </label>
                        :   <label className="check-box" style={{width:'45%', fontSize:'13px', color:'#fff', marginBottom:'25px'}} key={i}>
                                <input type="checkbox" name={name} value={list.title} id={target + list.code} onClick={(e)=>onClickEtc(e, list.code)} /><i></i>{list.title}
                            </label>
                ))
            }
        </Fragment>
    );
}

const InoculationYear = (props) => {
    const { yearList, index, dataList } = props;

    return(
        <div className="select-custom-box" id={'inocu'+ dataList.id}>
            <a className="btn-select inb" style={{padding:'0 0 0 15px'}} id={dataList.id} onChange={()=>testClick()}>
                {
                    (dataList.value == "N" || dataList.value == "") ? "미접종"
                        : dataList.value == "Y" ? "기억안남"
                            : dataList.value
                }
            </a>
            <ul style={{height:'15rem', overflow:'auto'}}>
                <li>
                    <a>미접종</a>
                </li>
                <li>
                    <a>기억안남</a>
                </li>
                {yearList.map((m,i) => (
                    <li key={i}>
                        <a>{m}</a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

const InoculationYear2 = (props) => {
    const { yearList, index, dataList } = props;

    return(
        <div className="select-custom-box" id={'inocu'+ dataList.id}>
            <a className="btn-select inb" style={{padding:'0 0 0 15px'}} id={dataList.id} onChange={()=>testClick()}>
                {
                    (dataList.value == "N" || dataList.value == "") ? "미검사"
                        : dataList.value == "Y" ? "기억안남"
                            : dataList.value
                }
            </a>
            <ul style={{height:'15rem', overflow:'auto'}}>
                <li>
                    <a>미검사</a>
                </li>
                <li>
                    <a>기억안남</a>
                </li>
                {yearList.map((m,i) => (
                    <li key={i}>
                        <a>{m}</a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

const InoculationList = (props) => {
    const { userinfo } = useContext(AppContext);
    const { dataList, yearList, dataList2 } = props;
    const [testYn, setTestYn] = useState('N');

    return(
        <Fragment>
            {dataList && dataList.map((list, i) => (
                userinfo.sex == "1"
                    ?   (list.title != "자궁경부암(여자)")  &&
                            <div key={i}>
                                <div className="txt">{list.title}</div>
                                <InoculationYear yearList={yearList} index={i} dataList={list} />
                            </div>
                    :   <div key={i}>
                            <div className="txt">{list.title}</div>
                            <InoculationYear yearList={yearList} index={i} dataList={list} />
                        </div>
            ))}

            {dataList2 && dataList2.map((list, i) => (
                userinfo.sex == "1"
                    ?   (list.title != "자궁경부암(여자)")  &&
                            <div key={i}>
                                <div className="txt">{list.title}</div>
                                <InoculationYear2 yearList={yearList} index={i} dataList={list} />
                            </div>
                    :   <div key={i}>
                            <div className="txt">{list.title}</div>
                            <InoculationYear2 yearList={yearList} index={i} dataList={list} />
                        </div>
            ))}
        </Fragment>
    );
}

export const Health = (props) => {
    const {userinfo, phonecfg} = useContext(AppContext);
    const {healthInfo} = props;

    const inoculationList = [
        {
            title: 'B형간염'
            , id: 'hpttsBVcnt'
            , value: healthInfo.hpttsBVcnt
        },
        {
            title: 'A형간염'
            , id: 'hpttsAVcnt'
            , value: healthInfo.hpttsAVcnt
        },
        {
            title:'폐렴구균 13가(프리베나)'
            , id: 'pnmn13Vcnt'
            , value: healthInfo.pnmn13Vcnt
        },
        {
            title:'폐렴구균 23가'
            , id: 'pnmn23Vcnt'
            , value: healthInfo.pnmn23Vcnt
        },
        {
            title:'대상포진'
            , id: 'hrpztVcnt'
            , value: healthInfo.hrpztVcnt
        },
        {
            title:'독감'
            , id: 'infzVcnt'
            , value: healthInfo.infzVcnt
        },
        {
            title:'파상풍'
            , id: 'ttnsVcnt'
            , value: healthInfo.ttnsVcnt
        },
        {
            title:'Tdap(디프테리아, 파상풍, 백일해)'
            , id: 'TdapVcnt'
            , value: healthInfo.TdapVcnt
        },
        {
            title:'자궁경부암(여자)'
            , id: 'crvclCncrVcnt'
            , value: healthInfo.crvclCncrVcnt
        }
    ];

    const antiBodyTest = [
        {
            title: 'A형간염'
            , id: 'hpttsATest'
            , value: healthInfo.hpttsATest
        },
        {
            title: 'B형간염'
            , id: 'hpttsBTest'
            , value: healthInfo.hpttsBTest
        },
        {
            title: 'C형간염'
            , id: 'hpttsCTest'
            , value: healthInfo.hpttsCTest
        }
    ];

    const openInputPopup = () => {
        //현재 레이어 닫고
        closeLayerFn($(".myhealth-list-layer"));
        //"나의 건겅정보 입력" 레이어 열기
        userHabit(phonecfg, 'SM100_P02');
        openLayerFn($(".health-input-layer"));
    }

    const closeInfoPopup = () => {
        //현재 레이어 닫고
        closeLayerFn($(".myhealth-list-layer"));
    }

    return (
        <div className="blacklayer-container myhealth-list-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box">
                    <div className="blgr-title">MY 건강정보</div>
                    <div className="health-input-contain">
                        <div className="dot-txt-list">
                            <ul>
                                <li>
                                    <u>혈액형</u> {healthInfo.blodType}형 {healthInfo.blodTypeDtl}
                                </li>
                                <li>
                                    <u>키</u> {healthInfo.hght}cm
                                </li>
                                <li>
                                    <u>몸무게</u> {healthInfo.wght}kg
                                </li>
                                <li>
                                    <u>BMI</u>
                                    {(healthInfo.hght && healthInfo.wght) 
                                        ? ((healthInfo.wght / (healthInfo.hght * healthInfo.hght)) * 10000).toFixed(2)
                                        : '미등록'
                                    }
                                </li>

                                <li>
                                    <u>생활습관</u>
                                    {healthInfo.smokYn === "Y" ? " 흡연 (" + healthInfo.smokDtl + "개피/1일)" : "비흡연 "}
                                    <br />
                                    {healthInfo.drnkYn === "Y" ? " 음주 : " + (healthInfo ? drinkKindToText(healthInfo) : "종류")  + healthInfo.drnkDtl + "병" + "(" + healthInfo.drnkCnt + "회/주)" : "비음주 "}
                                </li>
                                
                                <li>
                                    <u>알레르기</u> {healthInfo.alrgYn === "Y" 
                                                        ? healthInfo.alrgDtl ?  "유" + "(" + healthInfo.alrgDtl + ")" : "유"
                                                        : "무"}
                                </li>
                                <li>
                                    <u>병력</u>
                                    {healthInfo.mdclHistDgnss != "" && "진단병력: " + healthInfo.mdclHistDgnss}
                                    <br />
                                    {healthInfo.mdclHistDrug != "" && "치료병력: " + healthInfo.mdclHistDrug}
                                </li>
                                <li>
                                    <u>항체검사</u>
                                    {
                                        antiBodyTest.map((m,i) => (
                                            (m.value != "" && m.value != "N") && m.title + " "
                                        ))
                                    }
                                </li>
                                <li>
                                    <u>가족력</u>
                                    {healthInfo.fmlyHistYn === "N"
                                        ?  "무"
                                        :   healthInfo.fmlyHistDtl 
                                    }
                                </li>
                                <li>
                                    <u>예방접종</u>
                                    {
                                        inoculationList.map((m, i) => (
                                            (m.value != "N") && m.title + ' '
                                        ))
                                        
                                    }
                                </li>
                            </ul>
                        </div>

                        <div className="tbns-area">
                            <a onClick={()=>openInputPopup()} className="btn-round gray btn-myinfmodify">
                                수정
                            </a>
                            <a onClick={()=>closeInfoPopup()} className="btn-round wht btn-close">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const Food = (props) => {
    return (
        <div className="blacklayer-container main-foodmenu-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box wht vertical">
                        <div className="blgr-title">식단</div>
                        <p className="under-txt">2020.08.02.아침식단</p>

                        <div className="food-photo-area">
                            <img src={_T_MEAL} alt="" />
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gree">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const CardEdit = (props) => {
    const   {request1911} = props;
    const   {auth, mypagecfg, userinfo, cfg, phonecfg, dispatch} = useContext(AppContext);
    let     HISTORY,BMI, BS ,BP,FOOD ,ACTIVE;
    //let     HISTORY ='N',BMI = 'N', BS ='Y',BP= 'Y',FOOD  ='N',ACTIVE = 'N';
    const   request1912 = (userinfo, cfg, cardType, cardId, useYn) => {
            PostApi1912(userinfo, cfg, phonecfg, cardType,  cardId, useYn)
            .then(res => {
                if(res.resultMsg === 'SUCCESS') {
                    // 저장 후 팝업 닫고 하단 페이지  새로고침
                    request1911(userinfo, cfg, "selfcard");
                    // defaultAppSetting(userinfo, cfg, phonecfg, dispatch);
                } else {
                    console.log("LOGOUT!!!");
                }
            })
            .catch(err => {
                console.log(err);
            });
        };

    const saveCardMgmt = () => {
      let screen = [];
      let status = [];

      $("input[name='viewYn']").each(function () {
        screen.push(this.id);
        status.push(this.checked ? "Y" : "N");
      });
      dispatch({ type: SELFCAED_MENU_SET, screen: screen, status: status });

      request1912(userinfo, cfg, "selfcard", screen, status);
      // 페이지 닫기
      closeLayerFn($(".myhealth-cards-layer"));
      // 하단 리로드
    };

    const layerClose = () => {
      closeLayerFn($(".myhealth-cards-layer"));
    };
    if (auth) {
      //useEffect(() => {

      if (!mypagecfg.selfcard) {
        dispatch(SELFCAED_MENU_ALL_SET, getCookie("selfCard"));
      }

      if (mypagecfg.selfcard.BP && mypagecfg.selfcard.BP.cardYn === "Y") {
        $("#BP").attr("checked", true);
      }
      //       BP = mypagecfg.selfcard.BP.cardYn?mypagecfg.selfcard.BP.cardYn:'N';

      if (mypagecfg.selfcard.BS && mypagecfg.selfcard.BS.cardYn === "Y") {
        $("#BS").attr("checked", true);
      }
      //       BS = mypagecfg.selfcard.BS.cardYn?mypagecfg.selfcard.BS.cardYn:'N';

      if (mypagecfg.selfcard.BMI && mypagecfg.selfcard.BMI.cardYn === "Y") {
        $("#BMI").attr("checked", true);
      }
      //BMI = mypagecfg.selfcard.BMI.cardYn?mypagecfg.selfcard.BMI.cardYn:'N';

      if (mypagecfg.selfcard.FOOD && mypagecfg.selfcard.FOOD.cardYn === "Y") {
        $("#FOOD").attr("checked", true);
      }
      //FOOD = mypagecfg.selfcard.FOOD.cardYn?mypagecfg.selfcard.FOOD.cardYn:'N';

      if (
        mypagecfg.selfcard.ACTIVE &&
        mypagecfg.selfcard.ACTIVE.cardYn === "Y"
      ) {
        $("#ACTIVE").attr("checked", true);
      }
      //ACTIVE = mypagecfg.selfcard.ACTIVE.cardYn?mypagecfg.selfcard.ACTIVE.cardYn:'N';

      if (
        mypagecfg.selfcard.HISTORY &&
        mypagecfg.selfcard.HISTORY.cardYn === "Y"
      ) {
        $("#HISTORY").attr("checked", true);
      }
      //HISTORY = mypagecfg.selfcard.HISTORY.cardYn?mypagecfg.selfcard.HISTORY.cardYn:'N' ;
      if (
        mypagecfg.selfcard.ALLERGY &&
        mypagecfg.selfcard.ALLERGY.cardYn === "Y"
      ) {
        $("#ALLERGY").attr("checked", true);
      }

      if (
        mypagecfg.selfcard.STUDYRESULT &&
        mypagecfg.selfcard.STUDYRESULT.cardYn === "Y"
      ) {
        $("#STUDYRESULT").attr("checked", true);
      }
    } else {
      $("#BP").attr("checked", true);
      $("#BS").attr("checked", true);
    }
    //}, [mypagecfg.selfcard])
    return (
        <div className="blacklayer-container myhealth-cards-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea">
                <a onClick={layerClose} className="btn-setlayer-close"></a>
                <div>
                    <div className="myhealth-state-container">
                        <div className="card long green">
                            {/* <div className="card long check-card" style={{backgroundColor:"#afddd4"}}> */}
                            {/* {
                        mypagecfg.selfcard.BP.mndtYn === "N"
                            &&  <div className="check-area">
                                    <label>
                                        <input type="checkbox" name="viewYn" id="BP" />
                                        <i></i>
                                    </label>
                                </div>
                        } */}

                            <div>
                                <div className="title">
                                    <i className="c1"></i> 혈압
                                </div>

                                <div
                                    className="in-value-info"
                                    style={{ paddingTop: "4.842615vw" }}
                                >
                                    <div>
                                        <span>수축기</span>
                                        <p>
                                            140<em> mmgh</em>
                                        </p>
                                    </div>
                                    <div>
                                        <span>이완기</span>
                                        <p>
                                            80<em> mmgh</em>
                                        </p>
                                    </div>
                                </div>

                                <div className="date-time">
                                    2020.05.11(월) 06:20 <i></i>
                                </div>
                            </div>
                        </div>

                        {/* <div className="card long blue">
                            <div className="check-area">
                                <label>
                                    <input type="checkbox" name="viewYn" id="BMI" />
                                    <i></i>
                                </label>
                            </div>
                            <div>
                                <div className="title">
                                    <i className="c2"></i> BMI
                                </div>

                                <div className="in-value-info">
                                    <div>
                                        <span></span>
                                        <p></p>
                                    </div>
                                    <div>
                                        <span></span>
                                        <p>
                                            35.5<em> kg/㎡</em>
                                        </p>
                                    </div>
                                </div>

                                <div className="date-time">
                                    2020.05.11(월) 06:20 <i></i>
                                </div>
                            </div>
                        </div> */}

                        <div className="card long pink">
                            <div>
                                <div className="title">
                                    <i className="c3"></i> 혈당
                                </div>

                                <div className="in-value-info">
                                    <div>
                                        <span></span>
                                        <p></p>
                                    </div>
                                    <div>
                                        <span></span>
                                        <p>
                                            143<em> mg/dL</em>
                                        </p>
                                    </div>
                                </div>

                                <div className="date-time">
                                    2020.05.11(월) 06:20 <i></i>
                                </div>
                            </div>
                        </div>

                        {/* <div className="card long check-card">
                <div className="check-area">
                  <label>
                    <input type="checkbox" name="viewYn" id="FOOD" />
                    <i></i>
                  </label>
                </div>
                <div>
                  <div className="title">
                    <i className="c4"></i> 식단
                  </div>

                  <div className="aday-meal">
                    <div>
                      <span className="on">아침</span>
                    </div>
                    <div>
                      <span className="on">점심</span>
                    </div>
                    <div>
                      <span>저녁</span>
                    </div>
                  </div>

                  <div className="date-time">
                    2020.05.11(월) 06:20 <i></i>
                  </div>
                </div>
              </div> */}

                        {/* 검사결과 */}
                        <div className="card long check-card">
                            {/* <div className="check-area">
                  <label>
                    <input type="checkbox" name="viewYn" id="STUDYRESULT" />
                    <i></i>
                  </label>
                </div> */}

                            <div style={{ backgroundColor: "#E3E052" }}>
                                <div className="title">
                                    <i className="c9"></i>검사결과
                                </div>

                                <div className="aday-meal">
                                    <div>
                                        <span
                                            className="on"
                                            style={{ width: "100%" }}
                                        >
                                            <i className="cm1"></i>당화혈색소
                                        </span>
                                    </div>
                                </div>

                                <div className="date-time">
                                    2020.05.11(월) 06:20 <i></i>
                                </div>
                            </div>
                        </div>
                        {/* 검사결과 */}

                        {/* <div className="card long check-card">
                            <div className="check-area">
                                <label>
                                    <input type="checkbox" name="viewYn" id="HISTORY" />
                                    <i></i>
                                </label>
                            </div>
                            <div>
                                <div className="title">
                                    <i className="c5"></i> 과거이력
                                </div>

                                <div className="aday-meal pur">
                                    <div>
                                        <span className="on">
                                            <i className="cm1"></i>백신접종
                                        </span>
                                    </div>
                                    <div>
                                        <span className="on">
                                            <i className="cm2"></i>항체검사
                                        </span>
                                    </div>
                                    <div>
                                        <span>
                                            <i className="cm3"></i>알레르기
                                        </span>
                                    </div>
                                </div>

                                <div className="date-time">
                                    2020.05.11(월) 06:20 <i></i>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="card long check-card">
                <div className="check-area">
                  <label>
                    <input type="checkbox" name="viewYn" id="ACTIVE" />
                    <i></i>
                  </label>
                </div>
                <div>
                  <div className="title">
                    <i className="c6"></i> 운동
                  </div>

                  <div className="date-time">
                    2020.05.11(월) 06:20 <i></i>
                  </div>
                </div>
              </div> */}

                        <div className="card long check-card">
                            {/* {
                                mypagecfg.selfcard.ALLERGY.mndtYn === "N"
                                    &&  <div className="check-area">
                                            <label>
                                                <input type="checkbox" name="viewYn" id="ALLERGY" />
                                                <i></i>
                                            </label>
                                        </div>
                            } */}
                            <div>
                                <div className="title">
                                    <i className="c7"></i> 알레르기
                                </div>

                                <div className="aday-meal pur">
                                    <div>
                                        <span className="on">
                                            <i className="cm1"></i>백신접종
                                        </span>
                                    </div>
                                    <div>
                                        <span className="on">
                                            <i className="cm2"></i>항체검사
                                        </span>
                                    </div>
                                    <div>
                                        <span>
                                            s<i className="cm3"></i>알레르기
                                        </span>
                                    </div>
                                </div>

                                <div className="date-time">
                                    2020.05.11(월) 06:20 <i></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="btn-mh-area">
                        <a className="btn-mycard-save" onClick={saveCardMgmt}>
                            목록 저장
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};